import { ContestWinnerSms } from "./ContestWinnerSms";
import { ContestWinner } from "./ContestWinner";
import React, { useEffect, useState } from 'react';
import { Button, MenuItem, TextField, Typography } from '@material-ui/core';
import apiURL from '../../apiURL';

export const ContestParticipants = ({ contestId }: { contestId: string }) => {
    const [events, setEvents] = useState<any[]>([]);
    const [eventId, setEventId] = useState('');
    const [entries, setEntries] = useState<any[]>([]);
    const [search, setSearch] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!contestId) return;
        const token = localStorage.getItem('auth') || '';
        fetch(`${apiURL}/contest-admin/${contestId}/events`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => {
                if (!r.ok) throw new Error();
                return r.json();
            })
            .then(data => setEvents(Array.isArray(data) ? data : []))
            .catch(() => setMessage('Impossible de charger les événements.'));
    }, [contestId]);

    const loadEntries = async () => {
        if (!eventId) return;
        setMessage('');
        const token = localStorage.getItem('auth') || '';
        try {
            const r = await fetch(
                `${apiURL}/contest-admin/${contestId}/entries/${eventId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (!r.ok) throw new Error();
            const data = await r.json();
            setEntries(Array.isArray(data) ? data : []);
        } catch {
            setEntries([]);
            setMessage('Impossible de charger les participants.');
        }
    };

    const filtered = entries.filter(e =>
        !search || String(e.number).includes(search.trim())
    );

    return (
        <div style={{ padding: 20 }}>
            <Typography variant="h6">Participants du jeu concours</Typography>
            <TextField select fullWidth label="Événement"
                value={eventId} margin="normal"
                onChange={e => {
                    setEventId(e.target.value);
                    setEntries([]);
                }}>
                {events.map(e => (
                    <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                ))}
            </TextField>
            <Button variant="contained" color="primary"
                disabled={!eventId} onClick={loadEntries}>
                Afficher les participants
            </Button>
            <Typography style={{ marginTop: 20 }}>
                Participants affichés : {entries.length}
            </Typography>
            <TextField label="Rechercher un numéro de ticket"
                value={search} onChange={e => setSearch(e.target.value)}
                margin="normal" fullWidth />
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            {['Ticket', 'Participant', 'Téléphone', 'Inscription', 'Statut', 'SMS'].map(h =>
                                <th key={h} style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #ccc' }}>{h}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map(e => (
                            <tr key={e.id}>
                                <td style={{ padding: 12 }}>#{e.number}</td>
                                <td>{e.firstname}</td>
                                <td>{e.phone}</td>
                                <td>{e.createdAt ? new Date(e.createdAt).toLocaleString('fr-FR') : '—'}</td>
                                <td>{e.is_winner ? 'Gagnant' : 'Participant'}</td>
                                <td style={{ padding: 12 }}>
                                    <ContestWinnerSms
                                        contestId={contestId}
                                        eventId={eventId}
                                        number={e.number}
                                        smsStatus={e.sms_status || 'not_sent'}
                                        simulated={Array.isArray(e.sms_history) &&
                                            e.sms_history.some((h: any) => h.status === 'simulated')}
                                        isWinner={!!e.is_winner}
                                        onSuccess={loadEntries}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {message && <Typography color="error">{message}</Typography>}
        
 {eventId && (
   <ContestWinner
     contestId={contestId}
     eventId={eventId}
     onSuccess={loadEntries}
   />
 )}
</div>
    );
};
